// extracted by mini-css-extract-plugin
module.exports = {"header-wrapper":"header-wrapper__203ff","header":"header__213Q3","body":"body__2I4so","page-main":"page-main__3GUQu","sidebar":"sidebar__14oOH"};